<template>
  <div>
    <div v-html="topHtml"></div>

    <div v-for="cert in certificates" :key="cert.id">
      <certificate-item :certificate="cert"></certificate-item>
    </div>
    <div v-html="bottomHtml"></div>
  </div>
</template>

<script>
import store from "@/store/index.js";
import CertificateItem from "@/components/CertificateItem.vue";

export default {
  name: "CertificateOverview",
  components: {
    CertificateItem,
  },
  data: () => {
    return {
      certificates: [],
    };
  },
  computed: {
    topHtml() {
      return store.state.viewConfiguration.certificateOverview.topHtml;
    },
    bottomHtml() {
      return store.state.viewConfiguration.certificateOverview.bottomHtml;
    },
  },
  mounted() {
    this.certificates = this.$route.params.certificates;
    //auto open only available certificate:
    if (
      store.state.isAutoRouteToSingleAvailalbeCertificate === true &&
      this.certificates.length === 1
    ) {
      let myCertificate = this.certificates[0];
      if (myCertificate.isAvailable === true) {          
        var url = `${store.state.apiUri}/detail/index/${store.state.eventCode}/${store.state.configCode}/${myCertificate.certificateCode}/${store.state.barcode}/${store.state.barcodeHash}`;
        this.$router.push({
          name: "CertificateDetail",
          params: { certificateUrl: url },
        });
      }
    }
  },
};
</script>

<style>
</style>